import { Component } from '@angular/core';

@Component({
  selector: 'app-set-electronics',
  templateUrl: './set-electronics.component.html',
  styleUrl: './set-electronics.component.scss',
})
export class SetElectronicsComponent {
  docsItems = [
    {
      title: '  شركة الشخص الواحد  ',
      image: 'assets/allServices/carouselsec.jpg',
    },
        {
      title: '   شركة مساهمة - التوصية بالأسهم ',
      image: 'assets/allServices/carouselsec.jpg',
    },    {
      title: '   شركات الأشخاص - تضامن - توصية بسيطة  ',
      image: 'assets/allServices/carouselsec.jpg',
    },
        {
      title: '  شركة ذات مسؤلية محدودة  ',
      image: 'assets/allServices/carouselsec.jpg',
    },    {
      title: '   تأسيس المنشأه الفردية ',
      image: 'assets/allServices/carouselsec.jpg',
    },
  ];
}
